// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hint-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
    width: 100%;
}

.hint-row {
    display: flex;
    flex-direction: row;
    gap: 10px;
}

.hint-item {
    background-color: transparent;
    border: 1px solid #2b2d2d;
    border-radius: 5px;
    padding: 10px;
    width: 50%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 10px;
}

.hint-item:hover {
    background-color: #2b2d2d;
    cursor: pointer;
}

.hint-item-logo {
    height: 100%;
    aspect-ratio: 1/1;
    margin-right: 5px;
    background-color: #202222;
    border-radius: 5px;

    display: flex;
    justify-content: center;
    align-items: center;
}

.hint-item-content {
    font-family: monospace;
    margin: 8px;
    color: #fff;
}

.hint-item-content span {
    display: inline-block;
    white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/components/HintSection.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;;IAElB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB","sourcesContent":[".hint-section {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 20px;\n    width: 100%;\n}\n\n.hint-row {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n}\n\n.hint-item {\n    background-color: transparent;\n    border: 1px solid #2b2d2d;\n    border-radius: 5px;\n    padding: 10px;\n    width: 50%;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    gap: 10px;\n}\n\n.hint-item:hover {\n    background-color: #2b2d2d;\n    cursor: pointer;\n}\n\n.hint-item-logo {\n    height: 100%;\n    aspect-ratio: 1/1;\n    margin-right: 5px;\n    background-color: #202222;\n    border-radius: 5px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.hint-item-content {\n    font-family: monospace;\n    margin: 8px;\n    color: #fff;\n}\n\n.hint-item-content span {\n    display: inline-block;\n    white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
